<template>
  <div class="choose full">
    <div class="choosecontent">
      <div class="choosetitle" style="font-size: 3vw;margin:0;letter-spacing: 20px;margin-top: 5%;">CHOOSE YOUR HOME</div>
      <div class="choosecontentdiv">
        <div style="width: 32%;height: 100%;margin-right: 10px;">
          <p style="text-align: start;font-size: x-large;font-weight: 600;margin-block-start: 0px;">Semi-D & Corner Terrace Units Type (Plot 1, 3, 4 & 5)</p>
          <p style="text-align: start;">Shan by ABN</p>
          <p style="text-align: start;">
            Wind whistling in the trees, chirping of the birds,
            rustling of lush greenery, these sounds of nature invites you to
            Shan by ABN Holdings. Feel tranquility embrace as you step into this
            sanctuary surrounded by tropical landscape. Sitting on Pasir Panjang
            Hill, this landed enclave perched on a hill enjoys a natural vantage
            point overlooking the green surrounding that cocoons its. This
            natural elevation heightens its privacy and lends exclusivity to its
            owners. Extending from the sense of space that nature brings, every
            house is designed with double volume windows, generous indoor and
            outdoor spaces.
          </p>
          <div >
          <img style="width: 40%;margin: .5rem;"  :src="GLOBAL.imgserve+'/choose/plot1.png'" @click="startchoosepop('/choose/X_PLOT-1.jpg')" alt="" />
          <img style="width: 40%;margin: .5rem;" :src="GLOBAL.imgserve+'/choose/plot4.png'" @click="startchoosepop('/choose/X_PLOT-4.jpg')" alt="" />
          <img style="width: 40%;margin: .5rem;" :src="GLOBAL.imgserve+'/choose/plot3.png'" @click="startchoosepop('/choose/X_PLOT-3.jpg')" alt="" />
          <img style="width: 40%;margin: .5rem;" :src="GLOBAL.imgserve+'/choose/plot5.png'" @click="startchoosepop('/choose/X_PLOT-5.jpg')" alt="" />

          </div>
        </div>

        <div style="width: 65%;height: 100%;">
          <img  :src="GLOBAL.imgserve+'/choose/chooseImg.png'" alt="" />
        </div>
      </div>
    </div>
    <div class="choosepop" v-show="choosepop">
      <div class="back btn"  @click="endpop(false)"><img  :src="GLOBAL.imgserve+'/btn/X.png'" alt=""></div>
      <div style="width: 100%;height: 100%;background: white;">
	<motion v-bind:zoomsize="zoomsizes" @setzoomsize="setzoomsize" :index="index" :btn="true">
        <img  ondragstart="return false;"  :src="GLOBAL.imgserve+popimg" alt="">
        </motion>
      </div>
    </div>
  </div>
</template>

<script>
import motion from "@/components/motion.vue";

export default {
    	  components: {
    motion,
  },
  data() {
    return {
      choosepop:false,
      popimg:"/choose/chooseImg.png",
      zoomsizes:1,
      index:2
    };
  },
  methods:{

    startchoosepop(vl){
      this.choosepop = true
      this.popimg = vl
    },
        setzoomsize(data) {
      this.zoomsizes = data;
    },
    endpop(){
      this.choosepop = false
    }
  }
};
</script>

<style>
.choose {

}

.choosetitle{

}

.choosepop{
    position: fixed;
    width: 90%;
    height: 90%;
    z-index: 100;
}


.choosecontent{
  width: 80%;
  height: 100%;
  /* display: flex; */
  /* justify-content: space-around; */
  /* align-items: center; */
}
.choosecontentdiv{
  width: 100%;
  height: 75%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}


</style>



